import React from 'react';
import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
} from '../../components';
import { Link } from 'react-router-dom';

import css from './WhyDoMenCheatPage.module.css';
import image from './about-us-1056.jpg';
import { useIntl } from 'react-intl';

import {WhyDoMenCheat_PAGE_TEXT } from './WhyDoMenCheatText';

import titleImage from './Title.jpg';
import profileIcon from './profileIcon.png'; // Update with the correct path


const updatedDate = "2/04/2024"; // This can be dynamically generated if required


const WhyDoMenCheatPage = () => {
  const { siteTwitterHandle, siteFacebookPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);
  const intl = useIntl();
  return (
    <StaticPage
      title="Why Do Men Cheat?"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'AboutPage',
        description: 'About ',
        name: 'About page',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>


        <LayoutWrapperMain className={css.staticPageWrapper}>
          <h1 className={css.pageTitle}>
            Why Do Men Cheat?
          </h1>

          <div className={css.topInfoBar}>

            <div className={css.rowC}>

            <img src={profileIcon} alt="Profile Icon" className={css.profileIcon} />

            <div>
            <div className={css.topInfoLine}>
              <span className={css.approval}>Clinically Approved By Shannon Bala</span>
              <span className={css.author}>By Precious Ogunkoya, Author</span>
            </div>
            <div className={css.bottomInfoLine}>
              <span className={css.reads}>18.4k Reads</span>
              <span className={css.updatedDate}>Updated: 4 Feb, 2024</span>
            </div>
            </div>

            </div>
          </div>


          <img src={titleImage} alt="Descriptive text about the image" className={css.yourImageClass} />


          <div className={css.contentWrapper}>

            <div className={css.contentMain}>

            <h2 className={css.pageContentsTitle}>
                Contents
              </h2>


              {/* Bullet Points with Links */}
              <ul className={css.contentsList}>
                <li><a href="#trueOrFalse">True or False: Every man is a cheater?</a></li>
                <li><a href="#importanceUnderstanding">Why is it important to understand why?</a></li>
                <li><a href="#reasonsMenCheat">40 reasons men cheat</a></li>
                <li><a href="#whatToDo">What to do if your man is cheating on you?</a></li>
                <li><a href="#mythsAboutCheating">Myths about why men cheat</a></li>
                <li><a href="#commonQuestions">Commonly asked questions about cheating</a></li>
              </ul>

              <div className={css.ParagraphBlock}>
              {/* Content Sections */}
              


              <p className={css.Paragraph}>
                {WhyDoMenCheat_PAGE_TEXT.intro1}
                {WhyDoMenCheat_PAGE_TEXT.intro2}
                {WhyDoMenCheat_PAGE_TEXT.intro3}
                <a className={css.Paragraph} href="https://www.loyalty-test.com">loyalty testing your partner</a>
                {WhyDoMenCheat_PAGE_TEXT.intro4}
              </p>


              <h2 className={css.SectionTitle}>
                True or False: Every man is a cheater?
              </h2>

              <p className={css.Paragraph} id="trueOrFalse">{WhyDoMenCheat_PAGE_TEXT.trueOrFalse1}</p>
              <p className={css.Paragraph}>{WhyDoMenCheat_PAGE_TEXT.trueOrFalse2}</p>

              <p className={css.Paragraph}>
                According to a <a className={css.Paragraph} href="https://ifstudies.org/blog/who-cheats-more-the-demographics-of-cheating-in-america">study</a>
                {WhyDoMenCheat_PAGE_TEXT.trueOrFalse3}
              </p>

              <h2 className={css.SectionTitle}>
                Why is it important to understand why?
              </h2>

              <p className={css.Paragraph} id="importanceUnderstanding">{WhyDoMenCheat_PAGE_TEXT.importanceUnderstanding1}</p>
              <p className={css.Paragraph}>{WhyDoMenCheat_PAGE_TEXT.importanceUnderstanding2}</p>

              <h2 className={css.SectionTitle}>
                40 Reasons Why Men Cheat
              </h2>

              <p className={css.Paragraph} id="reasonsMenCheat">{WhyDoMenCheat_PAGE_TEXT.reasonsMenCheat}</p>

              <ol className={css.orderedList}>
                <li>
                  <h3 className={css.subtitle2}>Internet:</h3>
                  <p className={css.Paragraph}>
                  {WhyDoMenCheat_PAGE_TEXT.Internet}
                  <a className={css.Paragraph} href="https://pubmed.ncbi.nlm.nih.gov/34431739/">26.6% of participants had participated in online cheating</a>
                  .
                  </p>
                </li>
                <li>
                  <h3 className={css.subtitle2}>Lack of Emotional Connection:</h3>
                    <p className={css.Paragraph}>
                      {WhyDoMenCheat_PAGE_TEXT.lackOfEmotionalConnection1}
                      <a className={css.Paragraph} href="https://www.everydayhealth.com/emotional-health/how-build-emotional-connection/#:~:text=Research%20published%20in%202021%20in,laughter%20can%20enhance%20social%20bonding.">lack of emotional connection</a>
                      {WhyDoMenCheat_PAGE_TEXT.lackOfEmotionalConnection2}
                      {WhyDoMenCheat_PAGE_TEXT.lackOfEmotionalConnection3}
                    </p>
                </li>
                <li>
                  <h3 className={css.subtitle2}>Poor Moral Judgement:</h3>
                  <p className={css.Paragraph}>{WhyDoMenCheat_PAGE_TEXT.poorMoralJudgment}</p>
                </li>
                <li>
                  <h3 className={css.subtitle2}>Seeking Validation:</h3>
                  <p className={css.Paragraph}>{WhyDoMenCheat_PAGE_TEXT.seekingValidation1}</p>
                  <p className={css.Paragraph}>{WhyDoMenCheat_PAGE_TEXT.seekingValidation2}</p>
                </li>
                <li>
                  <h3 className={css.subtitle2}>Ego Inflation:</h3>
                  <p className={css.Paragraph}>{WhyDoMenCheat_PAGE_TEXT.EgoInflation}</p>
                </li>  
                <li>
                  <h3 className={css.subtitle2}>Childhood Trauma:</h3>
                  <p className={css.Paragraph}>{WhyDoMenCheat_PAGE_TEXT.childhoodTrauma1}</p>
                  <p className={css.Paragraph}>{WhyDoMenCheat_PAGE_TEXT.childhoodTrauma2}</p>

                </li>
                <li>
                  <h3 className={css.subtitle2}>Lack Of Relationship Skills:</h3>
                
                  <p className={css.Paragraph}>
                  {WhyDoMenCheat_PAGE_TEXT.lackOfRelationshipSkills}
                  <a className={css.Paragraph} href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC5709195/">3.4 times more likely </a>
                   to cheat again.
                  </p>

                </li>
                <li>
                <h3 className={css.subtitle2}>Men Cheat for Avoidance, Culture, and Value:</h3>
                  <p className={css.Paragraph}>{WhyDoMenCheat_PAGE_TEXT.cheatForAvoidanceCultureValueIntro}</p>
                  <ul className={css.unorderedList}>
                    <li><strong className={css.Paragraph}>Value:</strong> {WhyDoMenCheat_PAGE_TEXT.cheatForValue}</li>
                    <li><strong className={css.Paragraph}>Avoidance:</strong> {WhyDoMenCheat_PAGE_TEXT.cheatForAvoidance}</li>
                    <li><strong className={css.Paragraph}>Culturally Absorbed:</strong> {WhyDoMenCheat_PAGE_TEXT.cheatForCulture}</li>
                  </ul>
                </li>
                <li>
                  <h3 className={css.subtitle2}>Fear Of Commitment:</h3>
                  <p className={css.Paragraph}>{WhyDoMenCheat_PAGE_TEXT.fearOfCommitment}</p>
                </li>
                <li>
                  <h3 className={css.subtitle2}>To Explore Sexual Preferences:</h3>
                  <p className={css.Paragraph}>{WhyDoMenCheat_PAGE_TEXT.ToExploreSexualPreferences}</p>
                </li>
                <li>
                  <h3 className={css.subtitle2}>Men Cheat When Their Partners Are Away:</h3>
                  
                  <p className={css.Paragraph}>
                  {WhyDoMenCheat_PAGE_TEXT.CheatWhenTheirPartnersAreAway1}
                  <a className={css.Paragraph} href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC5709195/">resort to adultery. </a>
                  {WhyDoMenCheat_PAGE_TEXT.CheatWhenTheirPartnersAreAway2}
                  </p>

                </li>
                <li>
                <h3 className={css.subtitle2}>Thrill-Seeking:</h3>
                  <p className={css.Paragraph}>{WhyDoMenCheat_PAGE_TEXT.ThrillSeeking}</p>
                  <ul className={css.unorderedList}>
                    <li><strong className={css.Paragraph}>Risk and Reward: </strong> {WhyDoMenCheat_PAGE_TEXT.riskAndReward}</li>
                    <li><strong className={css.Paragraph}>Novelty Factor: </strong> {WhyDoMenCheat_PAGE_TEXT.noveltyFactor}</li>
                  </ul>
                </li>
                <li>
                  <h3 className={css.subtitle2}>Lack of Admiration:</h3>
                  <p className={css.Paragraph}>{WhyDoMenCheat_PAGE_TEXT.LackOfAdmiration}</p>
                </li>
                <li>
                  <h3 className={css.subtitle2}>Unmet Physical Needs:</h3>
                  <p className={css.Paragraph}>{WhyDoMenCheat_PAGE_TEXT.UnmetPhysicalNeeds}</p>
                </li>             
                <li>
                  <h3 className={css.subtitle2}>Revenge:</h3>
                  <p className={css.Paragraph}>{WhyDoMenCheat_PAGE_TEXT.Revenge}</p>
                </li>   
                <li>
                  <h3 className={css.subtitle2}>Body image/Aging:</h3>
                  <p className={css.Paragraph}>{WhyDoMenCheat_PAGE_TEXT.BodyImageAging}</p>

                  <p className={css.Paragraph}>
                  {WhyDoMenCheat_PAGE_TEXT.BodyImageAging1}
                  <a className={css.Paragraph} href="https://markey.camden.rutgers.edu/files/2013/02/epa2013.pdf"> 2013 study published by Rutgers University</a>
                  {WhyDoMenCheat_PAGE_TEXT.BodyImageAging2}
                  </p>

                </li>   
                <li>
                  <h3 className={css.subtitle2}>Peer Pressure:</h3>
                  <p className={css.Paragraph}>{WhyDoMenCheat_PAGE_TEXT.PeerPressure}</p>
                </li>   
                <li>
                <h3 className={css.subtitle2}>Addiction:</h3>
                
                <p className={css.Paragraph}>
                <a className={css.Paragraph} href="https://my.clevelandclinic.org/health/diseases/22690-sex-addiction-hypersexuality-and-compulsive-sexual-behavior">Addiction </a>
                {WhyDoMenCheat_PAGE_TEXT.Addiction}
                 to cheat again.
                </p>

                  <p className={css.Paragraph}>{WhyDoMenCheat_PAGE_TEXT.Addiction}</p>
                  <ul className={css.unorderedList}>
                    <li><strong className={css.Paragraph}>Impaired Judgment:</strong> {WhyDoMenCheat_PAGE_TEXT.impairedJudgement}</li>
                    <li><strong className={css.Paragraph}>Escapism:</strong> {WhyDoMenCheat_PAGE_TEXT.Escapism}</li>
                    <li><strong className={css.Paragraph}>Loss of Control:</strong> {WhyDoMenCheat_PAGE_TEXT.LossOfControl}</li>
                  </ul>
                </li>
                <li>
                  <h3 className={css.subtitle2}>Weak Personal Boundaries:</h3>
                  <p className={css.Paragraph}>{WhyDoMenCheat_PAGE_TEXT.WeakPersonalBoundaries}</p>
                </li>
                <li>
                  <h3 className={css.subtitle2}>Men Love Adventure:</h3>
                  <p className={css.Paragraph}>{WhyDoMenCheat_PAGE_TEXT.MenLoveAdventure}</p>
                </li>
                <li>
                  <h3 className={css.subtitle2}>Parental Influence:</h3>
                  <p className={css.Paragraph}>{WhyDoMenCheat_PAGE_TEXT.ParentalInfluence}</p>
                </li>
                <li>
                  <h3 className={css.subtitle2}>Perceived Lack of Consequences:</h3>
                  <p className={css.Paragraph}>{WhyDoMenCheat_PAGE_TEXT.PerceivedLackOfConsequences}</p>
                </li>
                <li>
                  <h3 className={css.subtitle2}>When Your Partner Is Not Happy:</h3>
                  <p className={css.Paragraph}>{WhyDoMenCheat_PAGE_TEXT.PartnerIsNotHappy}</p>
                </li>
                <li>
                  <h3 className={css.subtitle2}>Unrealistic Expectations Of Monogamy:</h3>                
                  <p className={css.Paragraph}>
                    <a className={css.Paragraph} href="https://lsa.umich.edu/psych/news-events/all-news/faculty-news/it-s-time-to-admit-that-monogamy-has-always-been-doomed.html">Unrealistic Expectations of Monogamy</a>
                    {WhyDoMenCheat_PAGE_TEXT.UnrealistExpectationsOfMonogamy}
                  </p>

                </li>
                <li>
                  <h3 className={css.subtitle2}>Fear Of Loneliness:</h3>
                  <p className={css.Paragraph}>{WhyDoMenCheat_PAGE_TEXT.FearOfLoneliness}</p>
                </li>
                <li>
                  <h3 className={css.subtitle2}>Opportunistic Infidelity:</h3>
                  <p className={css.Paragraph}>{WhyDoMenCheat_PAGE_TEXT.OpportunisticInfidelity}</p>
                </li>
                <li>
                  <h3 className={css.subtitle2}>Missing Emotional Elements:</h3>
                  <p className={css.Paragraph}>
                    {WhyDoMenCheat_PAGE_TEXT.MissingEmotionalElements1}
                    <a className={css.Paragraph} href="https://www.allohealth.care/healthfeed/sex-education/emotional-void-in-relationship">emotional void</a>
                    {WhyDoMenCheat_PAGE_TEXT.MissingEmotionalElements2}
                  </p>

                </li>
                <li>
                  <h3 className={css.subtitle2}>Men Cheat When They Don't Feel Valued:</h3>
                  <p className={css.Paragraph}>{WhyDoMenCheat_PAGE_TEXT.MenCheatWhenTheyDontFeelValued1}</p>
                  <p className={css.Paragraph}>{WhyDoMenCheat_PAGE_TEXT.MenCheatWhenTheyDontFeelValued2}</p>
                </li>
                <li>
                  <h3 className={css.subtitle2}>Desire For Excitement</h3>
                  <p className={css.Paragraph}>{WhyDoMenCheat_PAGE_TEXT.DesireForExcitement}</p>
                </li>
                <li>
                  <h3 className={css.subtitle2}>Escape from Responsibility</h3>
                  <p className={css.Paragraph}>{WhyDoMenCheat_PAGE_TEXT.EscapeFromResponsibility}</p>
                </li>
                <li>
                <h3 className={css.subtitle2}>Impaired Judgment:</h3>
                  <p className={css.Paragraph}>{WhyDoMenCheat_PAGE_TEXT.impairedJudgement}</p>
                  <ul className={css.unorderedList}>
                    <li><strong className={css.Paragraph}>Distorted Perception:</strong> {WhyDoMenCheat_PAGE_TEXT.distortedPerception}</li>
                    <li><strong className={css.Paragraph}>Inhibited Communication:</strong> {WhyDoMenCheat_PAGE_TEXT.inhibitedCommunication}</li>
                    <li><strong className={css.Paragraph}>Temporary Escapism:</strong> {WhyDoMenCheat_PAGE_TEXT.temporaryEscapism}</li>
                  </ul>
                </li>
                <li>
                  <h3 className={css.subtitle2}>Modern Romantic Idea</h3>
                  <p className={css.Paragraph}>
                    {WhyDoMenCheat_PAGE_TEXT.ModernRomanticIdea1}
                    <a className={css.Paragraph} href="https://www.jstor.org/stable/20009874"> Modern Romantic Ideal </a>
                    {WhyDoMenCheat_PAGE_TEXT.ModernRomanticIdea2}
                  </p>
                </li>
                <li>
                  <h3 className={css.subtitle2}>Incompatibility</h3>
                  <p className={css.Paragraph}>{WhyDoMenCheat_PAGE_TEXT.Incompatibility}</p>
                </li>
                <li>
                  <h3 className={css.subtitle2}>Financial Stress</h3>
                  <p className={css.Paragraph}>
                    {WhyDoMenCheat_PAGE_TEXT.FinancialStress}
                    <a className={css.Paragraph} href="https://my.clevelandclinic.org/health/diseases/22690-sex-addiction-hypersexuality-and-compulsive-sexual-behavior"> Research done by the AICPA </a>
                     finds that 75% of Americans list financial decisions as a major stress in their relationship.
                  </p>
                </li>
                <li>
                  <h3 className={css.subtitle2}>Men Cheat When They Are Unable To Connect With Themselves</h3>
                  <p className={css.Paragraph}>{WhyDoMenCheat_PAGE_TEXT.MenCheatWhen}</p>
                </li>
                <li>
                  <h3 className={css.subtitle2}>Mid Life Crisis</h3>
                  <p className={css.Paragraph}>{WhyDoMenCheat_PAGE_TEXT.MidLifeCrisis}</p>
                </li>
                <li>
                  <h3 className={css.subtitle2}>Lack Of Intimacy</h3>

                  <p className={css.Paragraph}>
                    {WhyDoMenCheat_PAGE_TEXT.LackOfIntimacy1}
                    <a className={css.Paragraph} href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC5016345/"> lack of closeness </a>
                    {WhyDoMenCheat_PAGE_TEXT.LackOfIntimacy2}
                  </p>

                </li>
                <li>
                  <h3 className={css.subtitle2}>Delusion With Marriage</h3>
                  <p className={css.Paragraph}>{WhyDoMenCheat_PAGE_TEXT.DillusionWithMarrige}</p>
                </li>
                <li>
                  <h3 className={css.subtitle2}>Men seek love and attention</h3>
                  <p className={css.Paragraph}>{WhyDoMenCheat_PAGE_TEXT.MenSeekLoveandAttention}</p>
                </li>
                <li>
                  <h3 className={css.subtitle2}>Shame</h3>
                  <p className={css.Paragraph}>{WhyDoMenCheat_PAGE_TEXT.Shame1}</p>
                  <p className={css.Paragraph}>{WhyDoMenCheat_PAGE_TEXT.Shame2}</p>
                  <p className={css.Paragraph}>{WhyDoMenCheat_PAGE_TEXT.Shame3}</p>
                </li>          
              </ol>

              <h2 className={css.SectionTitle} id='whatToDo'>
                What To Do If Your Man Is Cheating On You
              </h2>
                <ul className={css.unorderedList}>
                    <li><strong className={css.Paragraph}>Stay calm: </strong> {WhyDoMenCheat_PAGE_TEXT.stayCalm}</li>
                    <li><strong className={css.Paragraph}>Get proof: </strong> {WhyDoMenCheat_PAGE_TEXT.getProof1} <a className={css.Paragraph} href="https://www.loyalty-test.com/ChooseTester">loyalty testing services</a> {WhyDoMenCheat_PAGE_TEXT.getProof2}</li>
                    <li><strong className={css.Paragraph}>Communicate: </strong> {WhyDoMenCheat_PAGE_TEXT.communicate}</li>
                    <li><strong className={css.Paragraph}>Seek Assistance: </strong> {WhyDoMenCheat_PAGE_TEXT.seekAssistance}</li>
                    <li><strong className={css.Paragraph}>Consider Counseling: </strong> {WhyDoMenCheat_PAGE_TEXT.considerCounseling}</li>
                    <li><strong className={css.Paragraph}>Set Boundaries: </strong> {WhyDoMenCheat_PAGE_TEXT.setBoundaries}</li>
                    <li><strong className={css.Paragraph}>Make Well-Informed Decisions: </strong> {WhyDoMenCheat_PAGE_TEXT.makeWellInformed}</li>
                </ul>

                <p className={css.Paragraph}>{WhyDoMenCheat_PAGE_TEXT.eachRelationship}</p>

              <h2 className={css.SectionTitle} id='mythsAboutCheating'>
                Myths About Why Men Cheat
              </h2>


              <div>
                <strong className={css.Paragraph}>Men Only Cheat to Feel Good About Their Bodies: </strong>
                <span className={css.Paragraph}>Although physical attraction may play a role, underlying causes may include emotional discontent, a lack of connection, or the need for affirmation.</span>
              </div>
              <div>
                <strong className={css.Paragraph}>Cheating in a relationship is invariably an indication of discontent: </strong>
                <span className={css.Paragraph}>The truth is not all cheaters are unhappy in their marriages; there are a variety of reasons why people commit infidelity.</span>
              </div>
              <div>
                <strong className={css.Paragraph}>Men Cheat Mostly Because They Don't Get Intimacy: </strong>
                <span className={css.Paragraph}>Common motivations that go beyond physical gratification include emotional neglect, unfulfilled needs, and the desire for excitement.</span>
              </div>
              <div>
                <strong className={css.Paragraph}>If You Cheat Once, You'll Cheat Again: </strong>
                <span className={css.Paragraph}>The truth is people can grow from their errors, and not all cheaters will carry out the same actions in other relationships.</span>
              </div>
              <div>
                <strong className={css.Paragraph}>It's Always Prearranged to Cheat: </strong>
                <span className={css.Paragraph}>There are times when adultery arises naturally and is motivated by external factors rather than a preempted situation.</span>
              </div>   


              <h2 className={css.SectionTitle} id='commonQuestions'>
                Common Questions Asked
              </h2>
                <ul className={css.unorderedList}>
                    <li><strong className={css.Paragraph}>Are They In Love With Someone Else?: </strong> {"If the response to this question is yes, it sets the direction the relationship will take. Two people cannot be in a relationship if one partner is in love with someone else."}</li>
                    <li><strong className={css.Paragraph}>Did You Have Feelings for the Other Person, or Was it Just Physical?: </strong> {"If it was only physical, one partner could find it easier to forgive. It could be simpler to forgive and regain trust after a physical affair. However, every situation is different."}</li>
                    <li><strong className={css.Paragraph}>Should I take up my suspicions with my partner?: </strong> {"It's critical to communicate openly. If doubts remain, think about having a calm and sincere conversation about your issues."}</li>
                    <li><strong className={css.Paragraph}>What if there is proof, but my partner says they didn't cheat: </strong> {"Denial is common. Consider seeking "}
                    <a className={css.Paragraph} href="https://openpathcollective.org/"> couples counseling </a>
                     {"to address the underlying problems and encourage open communication."}</li>
                </ul>

                <p className={css.Paragraph}>{WhyDoMenCheat_PAGE_TEXT.conclusion}</p>
  

              </div>

            </div>
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default WhyDoMenCheatPage;
